import React, { Component } from 'react'
import { Link } from 'gatsby'
import styled, { ThemeConsumer } from 'styled-components'
import { Flex, Box } from '@rebass/grid'
import { useState } from 'react'
import IconChevron from '../images/vector/icon-chevron.svg'

const StyledAccordion = styled(Box)`
  border-bottom: 1px solid #f5f5f5;
  transition: all 0.2s ease-in-out;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    border-bottom-color: ${(props) =>
      props.theme.appearance === 'light'
        ? '#e9ecef'
        : 'rgba(255, 255, 255, 0.1)'};
  }
`

const StyledAccordionHeader = styled(Box)`
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) =>
      props.theme.appearance === 'light'
        ? '#f8f9fa'
        : 'rgba(255, 255, 255, 0.05)'};
  }

  h6 {
    display: inline-block;
    margin: 0;
    transition: color 0.2s ease-in-out;
  }

  svg {
    position: absolute;
    right: 32px;
    top: calc(50% - 8px);
    height: 16px;
    transition: transform 0.3s ease-in-out;
  }

  &.expanded svg {
    transform: rotate(90deg);
  }
`

const StyledAccordionBody = styled(Box)`
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-10px);
  padding: 0 32px;
  margin: 0;
  transition:
    max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    padding-top 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    padding-bottom 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.expanded {
    max-height: 1000px;
    opacity: 1;
    transform: translateY(0);
    padding-top: 16px;
    padding-bottom: 32px;
  }
`

const Accordion = (props) => {
  const [accordionState, setAccordionState] = useState('collapsed')

  function switchAccordionState() {
    if (accordionState == 'collapsed') {
      setAccordionState('expanded')
    } else {
      setAccordionState('collapsed')
    }
  }

  return (
    <StyledAccordion {...props}>
      <StyledAccordionHeader
        p="4"
        onClick={switchAccordionState}
        className={accordionState}>
        <h6>{props.question}</h6>
        <p className="faded" style={{ marginBottom: '0' }}>
          {props.description}
        </p>
        <IconChevron />
      </StyledAccordionHeader>
      <StyledAccordionBody className={accordionState}>
        {props.children}
      </StyledAccordionBody>
    </StyledAccordion>
  )
}

export default Accordion
